var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldDisplayAltcraftPopup)?_c('altcraft-popup',{attrs:{"type":_vm.altcraftPopupData.type},on:{"close":_vm.altcraftPopupClose,"subPush":_vm.altcraftPopupPush}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }